/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_RecommendedInputs */



/**
* | output |
* | --- |
* | "0.5s (Recommended)" |
*
* @param {Ocr_Sampling_RecommendedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_recommended = /** @type {((inputs?: Ocr_Sampling_RecommendedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_RecommendedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("0,5 s (Recommandé)")
	if (locale === "de") return /** @type {LocalizedString} */ ("0,5 s (Empfohlen)")
	if (locale === "it") return /** @type {LocalizedString} */ ("0,5 secondi (consigliato)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("0,5 с (рекомендуется)")
	if (locale === "es") return /** @type {LocalizedString} */ ("0,5 s (recomendado)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("0.5秒（推荐）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("0.5秒（推奨）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("0.5 सेकंड (अनुशंसित)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("0,5s (Recomendado)")
	return /** @type {LocalizedString} */ ("0.5s (Recommended)")
});